/**
 * Rebuilds a route plan to match the selected stop ids.
 * Stops that remain keep their previous order; newly added stops are appended.
 */
export const syncRoutePlanWithEntities = (
  selectedEntityIds: string[],
  currentRoutePlan?: string[] | null,
): string[] => {
  const selected = new Set(selectedEntityIds);
  const kept = (currentRoutePlan ?? []).filter((id) => selected.has(id));
  const keptSet = new Set(kept);
  const added = selectedEntityIds.filter((id) => !keptSet.has(id));
  return [...kept, ...added];
};
